import { createReducer, ReducerActionWithPayload, ReducerAction } from '../../../../utils/createReducer';
import { ApexInfluencer, InstagramUserImage, TiktokUserImage } from '@round/api';

export type ClientInfluencerUserImage = {
    influencerId: number;
    image: TiktokUserImage | InstagramUserImage;
};

export type ClientBookingContextState = {
    influencers: ApexInfluencer[];
    influencerImages: ClientInfluencerUserImage[];
    influencersInitialized: boolean;
    imagesInitialized: boolean;
    currency: number | undefined;
};

export type ClientBookingContextActions =
    | ReducerActionWithPayload<'initializeInfluencers', { influencers: ApexInfluencer[]; currency: number }>
    | ReducerActionWithPayload<'initializeImages', { influencerImages: ClientInfluencerUserImage[] }>
    | ReducerActionWithPayload<
          'addInfluencerToBooking',
          { influencer: ApexInfluencer; influencerImage?: ClientInfluencerUserImage }
      >
    | ReducerActionWithPayload<'removeInfluencerFromBooking', number>
    | ReducerAction<'reset'>;

export const initialState: ClientBookingContextState = {
    influencers: [],
    influencerImages: [],
    influencersInitialized: false,
    imagesInitialized: false,
    currency: undefined,
};

export default createReducer<ClientBookingContextState, ClientBookingContextActions>({
    reset: () => ({
        ...initialState,
    }),
    initializeInfluencers: (state, { payload }) => ({
        ...state,
        influencers: payload.influencers,
        currency: payload.currency,
        influencersInitialized: true,
        imagesInitialized: false,
    }),
    initializeImages: (state, { payload }) => ({
        ...state,
        influencerImages: payload.influencerImages,
        imagesInitialized: true,
    }),
    addInfluencerToBooking: (state, { payload }) => {
        const imageIsAlreadyInState = state.influencerImages
            .map((img) => img.influencerId)
            .includes(payload.influencer.id);
        if (!payload.influencerImage || imageIsAlreadyInState) {
            return {
                ...state,
                influencers: !state.influencers.includes(payload.influencer)
                    ? state.influencers.concat(payload.influencer)
                    : state.influencers,
            };
        }
        return {
            ...state,
            influencers: !state.influencers.includes(payload.influencer)
                ? state.influencers.concat(payload.influencer)
                : state.influencers,
            influencerImages: !state.influencerImages.includes(payload.influencerImage)
                ? state.influencerImages.concat(payload.influencerImage)
                : state.influencerImages,
        };
    },
    removeInfluencerFromBooking: (state, { payload }) => ({
        ...state,
        influencers: state.influencers.filter((influencer) => influencer.id !== payload),
        influencerImages: state.influencerImages.filter((img) => img.influencerId !== payload),
    }),
});
